import * as R from 'ramda';

import { LearningPathWithDuration } from '@/types';

export const sortLps = R.sortWith<LearningPathWithDuration>([
  R.ascend(R.prop('isCompleted')),
  R.ascend(R.prop('title')),
]);

export const groupLpsByCategory = (lps: LearningPathWithDuration[]) => {
  const groupedLps: Record<
    string,
    { groupKey: string; lps: LearningPathWithDuration[] }
  > = {};
  lps.forEach(lp => {
    const key = lp.topic?.name;

    if (key) {
      if (!groupedLps[key]) {
        groupedLps[key] = {
          groupKey: key,
          lps: [],
        };
      }
      groupedLps[key].lps.push(lp);
    }
  });

  return groupedLps;
};

export const sortAndGroupLearningPaths = (lps: LearningPathWithDuration[]) => {
  const groupedLps: Record<
    string,
    { groupKey: string; lps: LearningPathWithDuration[] }
  > = {};

  lps.forEach(lp => {
    const key = lp.topic?.name;

    if (key) {
      if (!groupedLps[key]) {
        groupedLps[key] = {
          groupKey: key,
          lps: [],
        };
      }
      groupedLps[key].lps.push(lp);
    }
  });

  const sortedGroupedLps = Object.values(groupedLps)
    .sort((a, b) => {
      return a.groupKey.localeCompare(b.groupKey);
    })
    .map(group => ({ ...group, lps: sortLps(group.lps) }));

  return sortedGroupedLps;
};
